<template>
  <tippy-component
    :animate-fill="false"
    :hide-on-click="false"
    :interactive-border="0"
    :placement="placement"
    :popper-options="popperOptions"
    :a11y="false"
    :theme="tippyTheme"
    :to="to"
    :distance="distance"
    :arrow="arrow"
    :delay="delay"
    :show-on-init="showOnInit"
    :max-width="maxWidth"
    animation="fade"
    :interactive="interactive"
    :append-to="appendTo"
    :enabled="enabled"
    :visible="visible"
    flip-on-update
    boundary="viewport"
    v-on="$listeners"
  >
    <slot></slot>
    <template #trigger>
      <slot name="trigger"></slot>
    </template>
  </tippy-component>
</template>

<script>
import { TippyComponent } from 'vue-tippy';

export default {
  name: 'VTooltip',
  components: {
    TippyComponent
  },
  props: {
    to: {
      type: String,
      default: undefined
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    distance: {
      type: Number,
      default: 3
    },
    delay: {
      type: Array,
      default: () => [0, 0]
    },
    theme: {
      type: String,
      default: 'hf-default-tooltip'
    },
    // дефолт из vue-tippy
    // говна какая..
    maxWidth: {
      type: Number,
      default: 350
    },
    size: {
      type: String,
      default: 'big' /* TODO: сделать "auto" дефолтным значением */
    },
    preventOverflow: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: Boolean,
      default: false
    },
    showOnInit: {
      type: Boolean,
      default: false
    },
    skidding: {
      type: Number,
      default: 0
    },
    appendTo: {
      type: [String, Function, Element, HTMLElement],
      default: 'parent'
    },
    interactive: {
      type: Boolean,
      default: true
    },
    enabled: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      popperOptions: {
        modifiers: {
          preventOverflow: {
            enabled: this.preventOverflow
          },
          offset: {
            offset: Number(this.skidding).toString()
          }
        }
      }
    };
  },
  computed: {
    tippyTheme() {
      return [this.theme, `hf-default-tooltip-${this.size}-size`].join(' ');
    }
  }
};
</script>

<style lang="less">
.hf-default-tooltip-big-size-theme {
  width: 400px;
}

.hf-default-tooltip-auto-size-theme {
  width: auto;
  /* попытка изобразить "max-content" */
  display: table;
  white-space: nowrap;
}

.hf-default-tooltip-theme {
  padding: 10px 20px;
  border-radius: 3px;
  background: #000000;
  color: #fff;
  opacity: 0.9;
  font-size: 14px;
  text-align: left;
}

.hf-wysiwyg-tooltip-theme {
  padding: 5px 6px;
  border-radius: 3px;
  background: #000000;
  color: #fff;
  opacity: 0.9;
  font-size: 12px;
  line-height: 16px;
}

.hf-default-tooltip-theme .tippy-backdrop {
  background: #000000;
}

.tippy-popper[x-placement^='bottom'] .hf-default-tooltip-theme .tippy-arrow {
  border-bottom-color: #000000;
}
</style>

<i18n lang="json" />
